'use client';

import { useGardenPlannerStore } from '@shared/store/useGardenPlannerStore';
import { useGardenPlannerContext } from '@modules/garden-planner/context/garden_planner_context';
import type { GardenPlannerViews } from '@modules/garden-planner/garden_planner_views';

interface ShareButtonContainerProps {
  views: GardenPlannerViews;
}

export function ShareButtonContainer({ views }: ShareButtonContainerProps) {
  const copySuccess = useGardenPlannerStore((state) => state.copySuccess);
  const { onShareCopy } = useGardenPlannerContext();
  const { ShareButtonView } = views;

  return <ShareButtonView copySuccess={copySuccess} onShareCopy={onShareCopy} />;
}
